export default {
  ar: {
    currencyFormat: {
      style: 'currency' as const,
      currency: 'Dirham',
    },
  },
}
